import withToggle from '../../../common/hoc/withToggle';

import StockTakingButton from './StockTaking';
import NewInventoryButton from './NewInventory';

export const StockTaking = withToggle('modal')(StockTakingButton);
export const NewInventory = withToggle('modal')(NewInventoryButton);
